// eslint-disable-next-line @typescript-eslint/no-var-requires
const path = require('path');

/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    defaultLocale: 'default',
    locales: ['default', 'en', 'zh-Hans', 'zh-Hant', 'fr'],
    localeDetection: false,
  },
  localePath: path.resolve('./public/public/discovery/locales'),
  localeStructure: '{{lng}}/{{ns}}',
  defaultNS: 'common',
};
